module.exports = __webpack_public_path__ + "img/htsq.cde7d180.png";